// extracted by mini-css-extract-plugin
module.exports = {"notAvailableTournaments":"styles_notAvailableTournaments__Xvwk6","container":"styles_container__zrb33","content":"styles_content__DhTKA"};